<template>
  <div class="box box-info">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Pay Grade" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText v-model.trim="name"  id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="minimumSalary">Minimum Salary</label>
            <InputText v-model.trim="minimumSalary"  id="minimumSalary"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="maximumSalary">Maximum Salary</label>
            <InputText v-model.trim="maximumSalary"  id="maximumSalary"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addPayGrade" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="payGradeList" :paginator="true" :rows="8" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N" field=""/>
      <Column header="Name" :sortable="true" field="name"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column header="Minimum Salary" :sortable="true" field="minimumSalary"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['minimumSalary']" />
        </template>
      </Column>
      <Column header="Maximum Salary" :sortable="true" field="maximumSalary"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['maximumSalary']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editPayGrade(slotProps.data)" />
          <!--        <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"-->
          <!--                @click="editSalesOrder(slotProps.data)"/>-->
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <!--        <Button v-else disabled class="p-button-raised p-button-danger"-->
          <!--                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
          <!-- Delete Button -->
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deletePayGrades"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
export default {
  name: 'payGrades',
  data() {
    return {
      displayBasic: false,
      name: '',
      minimumSalary: '',
      maximumSalary: '',
      loading: false,
      editing: false,
      payGradeId: null,
      deleteDialog: false,
      filters: {}
    }
  },
  computed: {
    payGradeList() {
      return this.$store.state.hr.payGradeList
    }
  },
  mounted() {
    this.findPayGradeList()
  },
  methods: {
    async findPayGradeList() {
      await this.$store.dispatch('loadPayGradeList')
    },
    async addPayGrade() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let payGrade = {
        id: this.payGradeId,
        name: this.name,
        minimumSalary: this.minimumSalary,
        maximumSalary: this.maximumSalary
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createPayGrade', payGrade)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updatePayGrade', payGrade)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editPayGrade(data) {
      this.editing = true
      this.payGradeId = data.id
      this.name = data.name
      this.minimumSalary = data.minimumSalary
      this.maximumSalary = data.maximumSalary
      this.openBasic()
    },
    async deletePayGrades(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let payGrades = {
        id: this.payGradeId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deletePayGrade', payGrades)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Pay Head ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    reset() {
      this.name = ''
      this.maximumSalary = ''
      this.minimumSalary = ''
      this.displayBasic = false
    },
    openDeleteDialog(id) {
      this.payGradeId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// payGrades.vue?2311b62a